import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CustomTag } from '../shared'
import styled from 'styled-components'

export interface Term {
  name: string
  fullName: string
}

export interface IMostPopularSearchesProps {
  terms: Array<Term>
  onClick: (term: string) => void
}

const MostPopularSearches: React.FC<IMostPopularSearchesProps> = ({ terms, onClick }) => {
  return (
    <Container>
      <Header>
        <FormattedMessage id='DropOffLocation.list.mostPopularSearch' />
      </Header>
      <PopularSearchesWrapper>
        {terms.slice(0, 7).map((term) => (
          <CustomTag
            key={term.fullName}
            onClick={() => onClick(term.fullName)}>
            {term.name}
          </CustomTag>
        ))}
      </PopularSearchesWrapper>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.h2`
  font-weight: 600;
  font-size: ${({ theme }) => theme.size.small};
  line-height: 18px;
  margin-bottom: 10px;
`
const PopularSearchesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 7px;
`

export default MostPopularSearches
